export const ADD_ATTACHMENT = 'ADD_ATTACHMENT'
export const UPDATE_ATTACHMENT = 'UPDATE_ATTACHMENT'
export const ATTACHMENT_DELETED = 'ATTACHMENT_DELETED'

export const FETCH_MEASURE_LIST = 'FETCH_MEASURE_LIST'
export const UPDATE_MEASURE = 'UPDATE_MEASURE'
export const UPDATE_MEASURE_TAGS = 'UPDATE_MEASURE_TAGS'
export const MEASURE_DELETED = 'MEASURE_DELETED'
export const ADD_MEASURE = 'ADD_MEASURE'
export const SELECT_MEASURE = 'SELECT_MEASURE'
export const DESELECT_MEASURE = 'DESELECT_MEASURE'
export const REORDER_MEASURES = 'REORDER_MEASURES'
export const CHANGE_MEASURE = 'CHANGE_MEASURE'

export const FETCH_CHECKPOINTS = 'FETCH_CHECKPOINTS'
export const FETCH_CHECKPOINTS_SUCCESS = 'FETCH_CHECKPOINTS_SUCCESS'
export const FETCH_CHECKPOINTS_ERROR = 'FETCH_CHECKPOINTS_ERROR'
export const DELETE_CHECKPOINT = 'DELETE_CHECKPOINT'
export const ADD_CHECKPOINT = 'ADD_CHECKPOINT'
export const UPDATE_CHECKPOINT = 'UPDATE_CHECKPOINT'
export const SELECT_CHECKPOINT = 'SELECT_CHECKPOINT'
export const DESELECT_CHECKPOINT = 'DESELECT_CHECKPOINT'
export const REORDER_CHECKPOINTS = 'REORDER_CHECKPOINTS'

export const FETCH_CATEGORY_LIST = 'FETCH_CATEGORY_LIST'
export const FETCH_CATEGORY_LIST_SUCCESS = 'FETCH_CATEGORY_LIST_SUCCESS'
export const FETCH_CATEGORY_LIST_ERROR = 'FETCH_CATEGORY_LIST_ERROR'
export const FETCH_SUBCATEGORIES = 'FETCH_SUBCATEGORIES'


export const CHOOSE_CATEGORY = 'CHOOSE_CATEGORY'
export const CHOOSE_SUBCATEGORY = 'CHOOSE_SUBCATEGORY'
export const START_LOADING_CATEGORIES = 'START_LOADING_CATEGORIES'
export const CHANGE_PAGE = 'CHANGE_PAGE'
export const ADD_CATEGORY = 'ADD_CATEGORY'
export const REORDER_CATEGORIES = 'REORDER_CATEGORIES'
export const REORDER_SUBCATEGORIES = 'REORDER_SUBCATEGORIES'

export const UPDATE_CATEGORY = 'UPDATE_CATEGORY'
export const UPDATE_SUBCATEGORY = 'UPDATE_SUBCATEGORY'
export const UNCHOOSE_SUBCATEGORY = 'UNCHOOSE_SUBCATEGORY'
export const UNCHOOSE_CATEGORY = 'UNCHOOSE_CATEGORY'
export const SEARCH_CATEGORY = 'SEARCH_CATEGORY'
export const ADD_SUBCATEGORY = 'ADD_SUBCATEGORY'
export const DELETE_SUBCATEGORY = 'DELETE_SUBCATEGORY'
export const DELETE_CATEGORY = 'DELETE_CATEGORY'
